import $ from 'jquery';


export default
{

    init()
    {
    },


    finalize()
    {
        // UI voto
        let stars = $(".wpcf7-radio").find(".wpcf7-list-item-label");
        stars.click(e => {
            stars.parent().removeClass("active");
            $(e.target).siblings("input").prop("checked", true);
            $(e.target).parent().addClass("active");
        });


        // Gestione logica thank-you
        const blocco_iniziale = $(".screen-start");
        const blocco_thankyou = $(".screen-thankyou");
        const blocco_promoter = $(".screen-promoter");

        document.addEventListener( 'wpcf7submit', e => {
            let voto = $(".wpcf7-radio input:checked")[0];

            if(voto && voto.value){
                let v = parseInt(voto.value);
                // console.log("VOTO => ", v);

                if(v >= 8){
                    //console.log("GRANDE!");
                    blocco_iniziale.hide();
                    blocco_promoter.removeClass("d-none");
                } else {
                    //console.log("VABBE!");
                    blocco_iniziale.hide();
                    blocco_thankyou.removeClass("d-none");
                }
            }

        }, false );

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateFeedback.js